<template>
  <v-app-bar color="secondary" class="primary--text" light app flat>
    <v-app-bar-nav-icon @click="toggleL"></v-app-bar-nav-icon>
    <v-toolbar-title v-html="title"></v-toolbar-title>
    <v-spacer></v-spacer>
    <template>
      <v-btn
        v-if="isMulti"
        :elevation="1"
        rounded
        color="white"
        small
        light
        class="primary--text"
        @click="popup('role')"
      >
        <v-icon left class="primary--text">mdi-home-city</v-icon>
        Ganti Peran
      </v-btn>
      <v-btn :elevation="1" fab color="white" small light @click.stop="toggleR" class="mx-2 pa-0">
        <v-avatar :size="32">
          <v-img :src="$imgUrl(avatar)" aspect-ratio="1" class="grey lighten-2"></v-img>
        </v-avatar>
      </v-btn>
      <popup-peran ref="role"></popup-peran>
    </template>
  </v-app-bar>
</template>
<script>
import { mapState } from 'vuex';
import { arrayFlat } from '@utils/format';
import PopupPeran from '../popup/Perans';
export default {
  components: {
    PopupPeran,
  },
  computed: {
    ...mapState('auth', {
      role: (state) => state.role,
      akun: (state) => (state.user && state.user.instansis) || {},
      peserta: (state) => (state.user && state.user.peserta) || {},
    }),

    ...mapState('preferensi', {
      operators: (state) => (state.preferensi && state.preferensi.operators) || {},
    }),

    isMulti() {
      const operators = arrayFlat((this.operators && Object.values(this.operators)) || []);
      return !!operators.length;
    },

    title() {
      return (this.$route.meta && this.$route.meta.title) || 'Home';
    },

    avatar() {
      return (
        (this.role === 'peserta'
          ? this.peserta && this.$getDeepObj(this.peserta, 'foto_url')
          : this.akun && this.$getDeepObj(this.akun, 'foto_url')) || 'admin.png'
      );
    },
  },
  methods: {
    toggleL() {
      this.$emit('toggleL');
    },
    toggleR() {
      this.$emit('toggleR');
    },
    popup(jenis) {
      this.$refs[jenis].open();
    },
  },
};
</script>
<style scoped>
.logos {
  font-family: Roboto;
  font-weight: bold;
}
</style>
